<template>
  <div id="app">
    <router-view />
    <BackToTop />

    <!-- <div class="loading-box df aic jcc" v-if="loadingFlog">
      <p>{{ $t('加载中') }} <img src="@/assets/images/img/loader.gif" alt=""></p>
    </div> -->

  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {


    }
  },

  created() {

  },
  mounted() {

    // this.$i18n.locale = lang; // 修改当前语言

    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
    if (Language) {
      this.$i18n.locale = Language;
    } else {
      this.$i18n.locale = 'zh';
    }

  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>
.loading-box {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;

  p {
    text-align: center;
    // font-size: 3.27vw;
    font-family: "harmonyos";
    color: #666666;
    margin-right: 2vw;
  }

  img {
    width: 24px;
  }
}
</style>
